import React from 'react';
import PropTypes from 'prop-types';
import { candidate } from './onboarding-form-candidate';
import ReactTooltip from 'react-tooltip';
import { FiInfo } from 'react-icons/fi';
import { useDimensions } from '../../../hooks/useDimensions';

function Summary(props) {
  const { data, redirectToStep } = props;
  const dimensions = useDimensions();
  const backTopersonalDetails = () => redirectToStep(candidate.PERSONAL);
  const backToAbout = () => redirectToStep(candidate.ABOUT);
  const {
    title,
    experience,
    skills,
    salaryExpectation,
    languages,
    geos,
    dreamJob,
    professionalExperience,
    employment,
  } = data;

  return (
    <>
      <div className="summary-data">
        <div className="row pb-2">
          <div className={dimensions.width < 576 ? 'col-10' : 'col-6'}>
            {' '}
            <h6 className="font-weight-bold mb-0">Tell us more about yourself</h6>
          </div>
          <div
            className={`${
              dimensions.width < 576 ? 'col-2' : 'col-6'
            } text-right btn btn-link py-0`}
            onClick={backToAbout}
          >
            Edit
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Current Position/Title</p>
          </div>

          <div className="col">
            <p className="card-subtitle font-weight-bold">{title}</p>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Work experience (years)</p>
          </div>

          <div className="col">
            <p className="card-subtitle font-weight-bold">{experience}</p>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Skills</p>
          </div>

          <div className="col">
            <div className="b-0">
              {skills.map(({ id, name }) => (
                <span key={id} className="badge badge-medium">
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">
              Salary expectations{' '}
              <FiInfo
                className="mb-1 salary-tooltip"
                data-tip
                data-for="password-info"
              />
              <ReactTooltip
                id="password-info"
                type="light"
                effect="solid"
                place="top"
                className="tooltip-shadow"
              >
                <p className="p-1 pb-0 mb-0">Monthly gross salary in USD</p>
              </ReactTooltip>
            </p>
          </div>

          <div className="col">
            <p className="card-subtitle font-weight-bold">${salaryExpectation}</p>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Language</p>
          </div>

          <div className="col">
            <div className="b-0">
              {languages.map(({ id, name }) => (
                <span key={id} className="badge badge-medium">
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Employment options</p>
          </div>

          <div className="col">
            {employment.map(({ id, name }) => (
              <span key={id} className="badge badge-medium">
                {name}
              </span>
            ))}
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">Cities</p>
          </div>

          <div className="col">
            <div className="b-0">
              {geos.map(({ id, name }) => (
                <span key={id} className="badge badge-medium">
                  {name}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="summary-data mh200">
        <div className="row pb-0">
          <div className="col-6">
            {' '}
            <h6 className="font-weight-bold mb-0">Personal details</h6>
          </div>
          <div
            className="col-6 text-right btn btn-link"
            onClick={backTopersonalDetails}
          >
            {' '}
            Edit
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            {' '}
            <p className="card-subtitle">
              Tell us about your professional experience.
            </p>
          </div>
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <div className="summary-body preserve-line">
              {professionalExperience}
            </div>
          </div>
        </div>
        <div className="row">
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <p className="card-subtitle">
              Tell us a little bit about your Dream job
            </p>
          </div>
          <div className={dimensions.width < 576 ? 'col-6' : 'col-5'}>
            <div className=" summary-body preserve-line">{dreamJob}</div>
          </div>
        </div>
      </div>
    </>
  );
}

Summary.propTypes = {
  data: PropTypes.object,
  redirectToStep: PropTypes.func,
};

export default Summary;
